// Angular import
import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

// 3rd Party imports
import { DxFormComponent, DxPopupComponent } from 'devextreme-angular';

// CC-Common import
import { DxWidgetUtils, IconConstants, Utils } from 'cc-common';

// Model imports
import { DimensionSelectorResultDto } from '../../../_models/common/dimensions/dimension-selector-result-dto';
import { DimensionOptionCodeRawDto } from '../../../_models/common/dimensions/dimension-option-code-raw-dto';

@Component({
    selector: 'app-dimension-selector',
    templateUrl: './dimension-selector.component.html',
    styleUrls: ['./dimension-selector.component.scss']
})
export class DimensionSelectorComponent {
    @ViewChild('dimensionSelectorPopup', { static: false }) dimensionSelectorPopup: DxPopupComponent;
    @ViewChild('dimensionSelectorForm', { static: false }) dimensionSelectorForm: DxFormComponent;

    @Input() visible: boolean;
    @Input() requiredDimensions: Array<DimensionSelectorResultDto>;

    @Output() onSelect = new EventEmitter<Array<DimensionOptionCodeRawDto>>();

    selectedDimensionOptions: Array<DimensionOptionCodeRawDto> = [];

    iconCheck = IconConstants.CHECK;
    iconCancel = IconConstants.CANCEL;

    onShown(): void {
        DxWidgetUtils.instantRepaint(this.dimensionSelectorPopup);
    }

    onHidden(): void {
        this.visible = false;
        this.onSelect.emit(null);
    }

    onDimChangeClick(e: any, data: DimensionSelectorResultDto): void {
        if (Utils.notNullAndDefined(data)) {
            if (Utils.notNullAndDefined(e.value)) {
                const dimParamIndex = this.selectedDimensionOptions.findIndex((obj) => {
                    return Utils.equalsIgnoreCase(obj.dimensionCode, data.code);
                });

                if (Utils.equals(dimParamIndex, -1)) {
                    const dimParam: any = {
                        dimensionCode: data.code,
                        dimensionOptionCode: e.value
                    };

                    this.selectedDimensionOptions.push(dimParam);
                } else {
                    this.selectedDimensionOptions[dimParamIndex].dimensionOptionCode = e.value;
                }
            } else {
                this.selectedDimensionOptions = this.selectedDimensionOptions.filter((obj) => {
                    return Utils.notEqualsIgnoreCase(obj.dimensionCode, data.code);
                });
            }
        }
    }

    onSelectClick(): void {
        if (DxWidgetUtils.hasInstance(this.dimensionSelectorForm)) {
            const validate = this.dimensionSelectorForm.instance.validate();
            if (Utils.isTrue(validate.isValid)) {
                this.onSelect.emit(this.selectedDimensionOptions);
            }
        }
    }
}
